export enum VisitationAnalyticsGroupBy {
  Workplace = 'WORKPLACE',
  Establishment = 'ESTABLISHMENT',
  Supplier = 'SUPPLIER',
  SupplierEmployee = 'SUPPLIER_EMPLOYEE',
  Activity = 'ACTIVITY',
  VisitedPerson = 'VISITED_PERSON',
  Hour = 'HOUR',
  Day = 'DAY',
  Week = 'WEEK',
  Month = 'MONTH',
}
